"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const translation_1 = require("../../../common/js/helper/translation");
const NavigationStore_1 = __importDefault(require("../../stores/NavigationStore"));
const ShortCutItem_1 = __importDefault(require("./ShortCutItem"));
const ShortCuts = () => (react_1.default.createElement("section", { className: "znd-dashboard-shortcuts" },
    react_1.default.createElement("div", { className: "znd-dashboard-shortcuts__subtitle t-body-tiny" }, (0, translation_1.t)('dashboard.shortcuts.subtitle')),
    react_1.default.createElement("nav", { className: "znd-dashboard-shortcuts__list" }, NavigationStore_1.default.shortCuts.map((item) => (react_1.default.createElement(ShortCutItem_1.default, { key: item.uuid, item: item }))))));
exports.default = ShortCuts;
